type VacanciesBlockProps = {
  readonly title: string
  readonly vacancies: ReadonlyArray<{
    /**
     * Markup
     */
    vacancyDescription: string
  }>
  readonly emptyListText: string
}

export default function VacanciesBlock({ title, vacancies, emptyListText }: VacanciesBlockProps) {
  return (
    <section>
      <h2>{title}</h2>

      {vacancies.length === 0 ? (
        <p>{emptyListText}</p>
      ) : (
        <ul>
          {vacancies.map(({ vacancyDescription }, index) => (
            <li key={index}>
              <div dangerouslySetInnerHTML={{ __html: vacancyDescription }} />
            </li>
          ))}
        </ul>
      )}
    </section>
  )
}
